import 'core-js/es/array/from';
import 'core-js/es/object/entries';
import 'core-js/es/symbol';
import 'core-js/es/symbol/iterator';
import 'promise-polyfill/src/polyfill';
import 'intersection-observer';

// ie11 'matches'
/* eslint-disable */
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector;
}

// custom event
(() => {
  if (typeof window.CustomEvent === 'function') return false; // If not IE

  const CustomEvent = (event, params) => {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    const evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();
